import { createFileRoute, Link } from '@tanstack/react-router';
import {
  Header,
  HeaderBackButton,
  HeaderButton,
  HeaderCopyButton,
  HeaderSidebarTrigger,
} from '@/app/ui/components/header';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from '@/app/ui/components/breadcrumb';
import { HugeiconsIcon } from '@hugeicons/react';
import { FileBookmarkIcon, PlusSignIcon } from '@hugeicons/core-free-icons';
import { MainScrollArea, MainHeader } from '@/app/ui/components/main';
import { Button } from '@/app/ui/components/button';
import { H1 } from '@/app/ui/components/heading';
import { CreateKnowledgeBase } from '@/app/components/features/organizations/CreateKnowledgeBase';
import OrganizationTemplates from '@/app/components/features/organizations/OrganizationTemplates';
import { useTranslations } from 'use-intl';
import { useGetFolderTree } from '@/app/hooks/queries/useFolders';
import { AppContext } from '@/app/appContext';
import { useContext } from 'react';

export const Route = createFileRoute('/_authed/(organization)/_layout/templates/')({
  component: RouteComponent,
});

function RouteComponent() {
  const t = useTranslations('pages.templates');
  const { userMeta } = useContext(AppContext);
  const organizationId = userMeta.organizationId ?? '';
  const { data: tree } = useGetFolderTree(organizationId);
  const hasData = tree && (tree.folders.length > 0 || tree.templateLists.length > 0);

  return (
    <>
      <CreateKnowledgeBase />
      <Header>
        <HeaderBackButton />
        <HeaderSidebarTrigger />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbPage>
                <HugeiconsIcon icon={FileBookmarkIcon} />
                {t('breadcrumbs.templates')}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <HeaderButton
          nativeButton={false}
          aria-label={t('buttons.newTemplate')}
          render={
            <Link to="/templates/new">
              <HugeiconsIcon icon={PlusSignIcon} />
            </Link>
          }
        />
        <HeaderCopyButton />
      </Header>
      <MainScrollArea>
        <MainHeader>
          <H1>{t('heading.templates')}</H1>
          <Button
            kind="with-icon"
            variant={!hasData ? 'secondary' : 'primary'}
            nativeButton={false}
            render={
              <Link to="/templates/new">
                <HugeiconsIcon icon={PlusSignIcon} />
                {t('buttons.newTemplate')}
              </Link>
            }
          />
        </MainHeader>
        <OrganizationTemplates />
      </MainScrollArea>
    </>
  );
}
